import styled, { css } from "styled-components";
import { color } from "../../../atoms/colors"
import { font } from "../../../atoms/typography"

export const Results = styled.div`
  background: ${color.common.lightBlue};
  border-radius: 8px;
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 24px;
  padding: 16px;
  ${(props) => props && props?.isDetail && css`
    background: none;
    padding: 0;
  `}
`

export const ResultsTitle = styled.h3`
  ${font('text', 'lg', '700')}
  color: ${color.common.black};
  ${(props) => props && props?.isDetail && css`
    ${font('display', 'xs', '700')}
  `}
`

export const Calcs = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 30px;
  grid-row-gap: 16px;
  align-items: center;
  @media (max-width: 992px) {
    grid-column-gap: 16px;
  }
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`

export const Text = styled.div`
  ${font('text', 'reg', '500')}
  color: ${color.grey[600]};
  max-width: 270px;
  ${(props) => props?.total && 
    css`
      ${font('text', 'lg', '600')}
      color: ${color.primary[800]};
      @media (max-width: 576px) {
        ${font('text', 'reg', '500')}
      }
    `
  }
  @media (max-width: 576px) {
    max-width: unset;
  }
`

export const Result = styled.div`
  text-align: right;
  ${font('display', 'xs', '900')}
  color: ${color.common.black};
  @media (max-width: 576px) {
    text-align: left;
    margin-top: -8px;
    ${font('text', 'lg', '900')}
  }
  ${(props) => props?.total && 
    css`
      ${font('display', 'md', '500')}
      color: ${color.primary[800]};
      @media (max-width: 576px) {
        ${font('display', 'sm', '500')}
      }
    `
  }
`